import React from 'react';

import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography4 } from 'uiToolkit/Typography';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextBox = styled.div`
  background: ${(props) => props.theme.palette.background.lightGrey4};
  border-radius: 4px 4px 0 0;
  border: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
  min-height: 100px;
  width: 60%;
`;

const TextBoxPreview = () => (
  <Wrapper>
    <TextBox darkBackground>
      <Typography4 leftGutter={3} topGutter={2} customColor={theme.palette.text.label}>
        User will enter text here
      </Typography4>
    </TextBox>
  </Wrapper>
);

export default TextBoxPreview;
